import dotProp from 'dot-prop-immutable'

import * as actions from '../actionTypes'

const initialState = {
  project: null,
}

const listingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.LISTING_PROJECT_REQUEST_SUCCESS: {
      const { project } = action.payload
      return dotProp.set(state, 'project', project)
    }
    default:
      return state
  }
}

export default listingReducer
